import { TextDescription, TextTitle } from "components/Texts";

import Column from "components/Column";
import ContactSpecialistBtn from "./ContactSpecialistBtn";
import DateFormatter from "../../modules/utils/DateFormatter";
import Icon from "components/Icon";
import KeywordZone from "./KeywordZone";
import NoTrackingData from "./NoTrackingData";
import React from "react";
import Row from "components/Row";
import Section from "components/Section";
import SuggestionNumber from "components/suggestions/SuggestionNumber";
import colors from "styles/colors";
import { useTranslation } from "react-i18next";

const LowPerformance = ({ data = {} }) => {
  //eslint-disable-next-line no-unused-vars
  const [t] = useTranslation();
  const keywords = data.keywords || [];
  const conversion3Months = data.conversion || 0;

  if (keywords.length) {
    return (
      <Section className="item" margin="0">
        <Row columnSpacing="8px" alignItems="center">
          <Column wrap>
            <Icon name="icon-sms-failed" size="26px" color={colors.primary} />
          </Column>
          <Column>
            <TextTitle>{t("__low_performance_keyword")}</TextTitle>
            <TextDescription>{`${t("__date_on")} ${DateFormatter.formatDateFull(data.startDate)} - ${DateFormatter.formatDateFull(data.endDate)}`}</TextDescription>
          </Column>
          <Column wrap>
            <SuggestionNumber bgColor={colors.negativePlus} color={colors.negative} number={keywords.length} />
          </Column>
        </Row>
        <KeywordZone data={keywords} />
        <Row margin="20px 0 16px 0">
          <ContactSpecialistBtn />
        </Row>
      </Section>
    );
  } else if (!conversion3Months) {
    return (
      <Section className="item" margin="0">
        <NoTrackingData name="low-performance" />
      </Section>
    );
  } else {
    return null;
  }
};

export default LowPerformance;
